import "./index.css"

import * as React from 'react'
import {render} from 'react-dom'
import App from '$src/bootstrap/App'

render(<App />, document.getElementById('root'))




// WEBPACK FOOTER //
// ./src/index.tsx